<template>
    <main>
        <Banner />
        <!-- <div class="cover"></div> -->
        <div class="double_arrow">
            <div class="scroll_wrapper" @click="selectElement">
                <i class="arrow1 down"></i>
                <div class="arrow-spacer"></div>
                <i class="arrow2 down"></i>
            </div>
        </div>


        <!-- <p class="arrow_main down"></p> -->

        <Marquee />
        <TotalRewardDescription v-if="agentStore.isLogin == false" />
        <PublishResult v-if="agentStore.isLogin == true" :totalRewardApiData="totalRewardApiData"
            :resultApiData="resultApiData" :annualResultApiData="annualResultApiData" :eventStatus="eventStatus"
            :annualEventStatus="annualEventStatus" :dateToCount="dateToCount" :annualDateToCount="annualDateToCount"
            :publishAnnualResultFunction="publishAnnualResult" :publishResultFunction="publishResult"
            :previousEventStatus="previousEventStatus" :previousResultApiData="previousResultApiData"
            :isAnnualPrizeClaimed="isAnnualPrizeClaimed" :previousAnnualResultApiData="previousAnnualResultApiData" />
        <!-- <PassResultFloatingIcon v-if="Object.keys(previousResultApiData).length > 0 && agentStore.isLogin == true" /> -->
        <RankBoard v-if="agentStore.isLogin == true && eventTypeList.length > 0" :eventTypeList="eventTypeList" />
        <!-- <EventBenefit v-if="agentStore.isLogin == true" :redPacketApiData="redPacketApiData"
            :checkRedPacketFunction="getRedPacket" /> -->
        <EventDescriptionTab v-if="agentStore.isLogin == false" />
        <whyDoo />
        <Footer />
        <Modals :totalRewardApiData="totalRewardApiData" :checkRedPacketFunction="getRedPacket"
            :getTotalRewardFunction="getTotalReward" :refreshFunction="getClaimedPrizeRecordList"
            :previousResultApiData="previousResultApiData" :previousAnnualResultApiData="previousAnnualResultApiData"
            :isAnnualPrizeClaimed="isAnnualPrizeClaimed" :previousEventStatus="previousAnnualEventStatus" />

    </main>
</template>
<script lang="ts">
import Banner from '@/components/Header/Banner.vue'
import Modals from '@/components/Modals/ModalMain.vue'
import EventDescriptionTab from '@/views/ib6/EventDescriptionTab.vue';
import { useCommonStore } from '@/stores/common'
import { useAgentStore } from '@/stores/user'
import Footer from "@/components/Footer/Footer_cms.vue";
import { getCookie, setCookie } from '@/service/cookie'
import { getLocation } from "@/api/location";
import { checkSession, getUserDetail, logout, signIn } from '@/api/auth'
import TotalRewardDescription from "@/views/ib6/totalRewardDescription.vue";
import whyDoo from "@/components/whyDoo.vue";
import RankBoard from "@/views/ib6/RankBoard.vue";
import EventBenefit from "@/views/ib6/home_event/EventBenefit.vue";
// model
import PublishResult from "@/views/ib6/PublishResult.vue";
import { getRedPacketStatus } from "@/api/red";
import { RedPacketData, RedPacketRoot } from "@/modal/RedPacket";
import { ClaimTypeData, TotalRewardData, TotalRewardRoot } from "@/modal/TotalReward";
import { getAchievedPrizeDetails, getAnnualReward, getClaimedPrizeRecord, getPublishResults } from "@/api/getResult";
import { numberWithCommas, padNumberWithZeros } from "@/service/general";
import { Gift, GoldInfo, GoldPrize, PrizeInfo, ResultData, ResultRoot } from "@/modal/Result";
import { AnnualGift, AnnualPrizeInfo, AnnualRewardData, AnnualRewardRoot } from "@/modal/AnnualReward";
import { activityTime, getAllLevel } from "@/api/ib4-0";
import PassResultFloatingIcon from "@/components/FloatingIcons/PassResultFloatingIcon.vue";
import { LevelList } from '@/modal/Level';
import Marquee from "@/components/Marquee/Marquee.vue";
import { apiActivityObject, claimedPrizeRecord } from "@/modal/ClaimedPrizeRecord";

export default {
    name: 'Home',
    components: {
        Banner,
        Modals,
        EventDescriptionTab,
        Footer,
        TotalRewardDescription,
        whyDoo,
        PublishResult,
        RankBoard,
        EventBenefit,
        PassResultFloatingIcon,
        Marquee,
    },
    data() {
        return {
            imageUrl: "https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/ib_event/ib6/images/",
            agentStore: useAgentStore(),
            commonStore: useCommonStore(),
            uuid: '',
            totalRewardApiData: {} as TotalRewardData,
            annualResultApiData: {} as AnnualRewardData,
            previousAnnualResultApiData: {} as AnnualRewardData,
            resultApiData: {} as ResultData,
            previousResultApiData: {} as ResultData,
            eventStatus: '',
            dateToCount: '',
            annualEventStatus: '',
            previousAnnualEventStatus: '',
            annualDateToCount: '',
            previousEventStatus: '',
            redPacketApiData: {} as RedPacketData,
            eventTypeList: [],
            annualEventTypeList: [],
            latestEvent: '',
            latestAnnualEvent: '',
            levelPrizeApiData: <LevelList[]>[],
            marqueeList: [],
            isAnnualPrizeClaimed: {} as apiActivityObject
        }
    },
    methods: {
        async tokenApi() {
            const keys = ['idTag', 'token'];
            const query = window.location.search;
            const result: Record<string, string> = {};

            // Parse the query string for specified keys
            const regex = new RegExp(`[?&](${keys.join('|')})=([^&#]*)`, 'gi');
            let match;
            while ((match = regex.exec(query)) !== null) {
                const key = match[1];
                const value = decodeURIComponent(match[2]);
                result[key] = value;
            }

            const token: string = result['idTag'] || result['token'];
            let validCountry: boolean = true;
            let defaultCountryCode = '';
            let countryCode = '';

            try {
                if (token) {
                    const isToken = Object.keys(result)[0] === 'token';
                    console.log(isToken)
                    const auth = isToken
                        ? await signIn(token)
                        : await getUserDetail({ idTag: token });
                    console.log(isToken)
                    if (document.referrer && isToken == true) {
                        setCookie("redirectLink", document.referrer, 1, "/", "", "");
                    }

                    let session = auth.data.data
                    countryCode = getCookie("countryCode") || session.countryCode;
                    defaultCountryCode = session.defaultCountryCode;

                    this.uuid = session.uuid
                    validCountry = this.checkValidCountryCode(defaultCountryCode);
                    this.commonStore.checkCRMURL();
                } else {

                    const session = await checkSession()

                    // const session = await signIn('dev')
                    if (session.data.code === 0) {
                        this.uuid = session.data.data.uuid

                        countryCode = getCookie("countryCode") || session.data.data.countryCode;
                        defaultCountryCode = session.data.data.defaultCountryCode;

                        validCountry = this.checkValidCountryCode(defaultCountryCode);

                    }

                }
                if (this.uuid != '') {
                    this.agentStore.setIsLogin(true);
                    this.agentStore.setUuid(this.uuid);
                    this.getTotalReward();

                    this.publishResult();
                    this.publishAnnualResult();
                    this.getClaimedPrizeRecordList();
                    // this.getRedPacket();
                }

                if (this.agentStore.isLogin == false) {
                    const location = await getLocation();

                    if (location.code == 0) {
                        defaultCountryCode = location.data.country_code
                    }
                }

                await this.commonStore.setAgentLocation(defaultCountryCode);
                if (window.location.pathname.includes('testmts')) {

                } else if (validCountry === true && countryCode != '') {
                    this.$router.push(`/${countryCode}`)
                }
                else if (validCountry === false) {
                    this.commonStore.openModal('InvalidCountry')
                }


            } catch (error) {
                console.log(error);
            }
        },
        async getRedPacket() {
            const { data }: { data: RedPacketRoot } = await getRedPacketStatus();
            this.redPacketApiData = data.data;
            if (data.data.isFestive == true) {
                this.commonStore.openModal('RedPacketHoliday')
            } else if (data.data.isDob == true) {
                this.commonStore.openModal('RedPacketBirthday')
            } else {
                this.commonStore.closeModal()
            }
        },
        async getTotalReward() {
            const { data }: { data: TotalRewardRoot } = await getAchievedPrizeDetails();
            if (data.code == 0) {
                data.data.totalPrizeClaimedText = numberWithCommas(data.data.totalPrizeClaimed);
                data.data.totalPendingPrizeText = numberWithCommas(data.data.totalPendingPrize);
                this.commonStore.setTotalAmountClaimed(data.data.totalPendingPrize);

                if (data.data.claimablePrize.length > 0) {
                    data.data.giftTypeKey = {} as ClaimTypeData;

                    for (let index = 0; index < data.data.claimablePrize.length; index++) {
                        const element = data.data.claimablePrize[index];
                        this.commonStore.annualPrizeCode = element.prizeProduct;
                        const tempData = {
                            giftType: element.activityType,
                            giftCode: element.prizeAmount || element.prizeProduct,
                            giftName: element.prizeAmount || element.prizeProduct,
                            eventType: element.eventType || element.annualType,
                        }
                        switch (element.activityType) {
                            case 0:
                                data.data.giftTypeKey.levelBonus = tempData
                                break;
                            case 1:
                                data.data.giftTypeKey.goldBonus = tempData
                                break;
                            case 2:
                                data.data.giftTypeKey.rankingGold = tempData
                                break;
                            case 3:
                                data.data.giftTypeKey.rankingVolume = tempData
                                break;
                            case 4:
                                data.data.giftTypeKey.rankingMIB = tempData
                            case 5:
                                data.data.giftTypeKey.annualBonus = tempData
                                break;
                        }
                        element.prizeAmountText = numberWithCommas(element.prizeAmount);
                    }
                }

                this.totalRewardApiData = data.data;
                if (data.data.isClaimable === true) {
                    this.commonStore.openModal('RewardList')
                }
            }
        },
        async publishAnnualResult() {
            const { data }: { data: AnnualRewardRoot } = await getAnnualReward();
            if (data.code == 0) {
                for (const key in data.data) {
                    const temp = data.data[key][0];

                    temp.totalInGold = numberWithCommas(temp.totalInGold);
                    temp.totalTransaVolume = numberWithCommas(temp.totalTransaVolume);


                    temp.annualPrizeInfo = {} as AnnualPrizeInfo
                    temp.annualPrizeInfo.gifts = {} as AnnualGift

                    if (Number(temp.target) < 3 && this.annualEventStatus == 'status2') {
                        temp.annualPrizeInfo.target = temp.nextAnnualPrizeVo.target;
                        temp.annualPrizeInfo.depositStandard = numberWithCommas(temp.nextAnnualPrizeVo.depositStandard);
                        temp.annualPrizeInfo.volumeStandard = numberWithCommas(temp.nextAnnualPrizeVo.volumeStandard);
                        temp.annualPrizeInfo.qualifiedCustomerNo = temp.nextAnnualPrizeVo.qualifiedCustomerNo

                        temp.annualPrizeInfo.gifts.giftName = numberWithCommas(temp.nextAnnualPrizeVo.gifts[0].giftName);
                        temp.annualPrizeInfo.gifts.giftCode = temp.nextAnnualPrizeVo.gifts[0].giftCode;
                    } else {
                        if (temp.target == '0') {

                            temp.annualPrizeInfo.target = temp.nextAnnualPrizeVo.target;
                            temp.annualPrizeInfo.depositStandard = numberWithCommas(temp.nextAnnualPrizeVo.depositStandard);
                            temp.annualPrizeInfo.volumeStandard = numberWithCommas(temp.nextAnnualPrizeVo.volumeStandard);
                            temp.annualPrizeInfo.qualifiedCustomerNo = temp.nextAnnualPrizeVo.qualifiedCustomerNo
                            //
                            temp.annualPrizeInfo.gifts.giftName = numberWithCommas(temp.nextAnnualPrizeVo.gifts[0].giftName);
                            temp.annualPrizeInfo.gifts.giftCode = temp.nextAnnualPrizeVo.gifts[0].giftCode;
                        } else {

                            temp.annualPrizeInfo.target = temp.annualPrizeVo?.target;
                            temp.annualPrizeInfo.depositStandard = numberWithCommas(temp.annualPrizeVo.depositStandard);
                            temp.annualPrizeInfo.volumeStandard = numberWithCommas(temp.annualPrizeVo.volumeStandard);
                            temp.annualPrizeInfo.qualifiedCustomerNo = temp.annualPrizeVo.qualifiedCustomerNo
                            //
                            temp.annualPrizeInfo.gifts.giftName = numberWithCommas(temp.annualPrizeVo.gifts[0].giftName);
                            temp.annualPrizeInfo.gifts.giftCode = temp.annualPrizeVo.gifts[0].giftCode;
                        }
                    }
                    if (Number(temp.target) == 0) {
                        temp.target = "1";
                    }
                }

                if (this.annualEventStatus == 'status2' || this.annualEventStatus == 'status3' || this.annualEventStatus == 'status4' || this.annualEventStatus == 'status5') {

                    this.previousAnnualResultApiData = data.data[this.annualEventTypeList[0]][0];
                }

                this.annualResultApiData = data.data[this.latestAnnualEvent][0];
            }
        },
        async publishResult() {
            const { data } = await getPublishResults();

            if (data.code == 0) {
                // console.log(data.data)
                for (const key in data.data) {
                    const temp = data.data[key][0];
                    //
                    temp.eventInGold = numberWithCommas(temp.eventInGold);
                    temp.tradingVolume = numberWithCommas(temp.tradingVolume);
                    temp.goldAmount = numberWithCommas(temp.goldAmount);
                    temp.totalCommission = numberWithCommas(temp.totalCommission);
                    //
                    temp.prizeInfo = {} as PrizeInfo
                    temp.prizeInfo.gifts = {} as Gift
                    temp.goldInfo = {} as GoldInfo
                    temp.goldInfo.goldPrize = {} as GoldPrize

                    if (temp.agentLevel < 9 && this.eventStatus == 'status2') {

                        temp.prizeInfo.depositStandard = numberWithCommas(temp.nextPrizeInfoLevelVo.depositStandard);
                        temp.prizeInfo.volumeStandard = numberWithCommas(temp.nextPrizeInfoLevelVo.volumeStandard);
                        temp.prizeInfo.gifts.giftName = numberWithCommas(temp.nextPrizeInfoLevelVo.gifts[0].giftName);
                        temp.prizeInfo.gifts.giftCode = temp.nextPrizeInfoLevelVo.gifts[0].giftCode;
                        // gold
                        if (temp.agentLevel > 0) {
                            temp.goldInfo.goldLot = numberWithCommas(temp.nextGoldPrizeLevelVo.goldLot);
                            temp.goldInfo.goldPrize.giftName = numberWithCommas(temp.nextGoldPrizeLevelVo.goldPrize[0].giftName);
                        }
                    } else {
                        //
                        if (temp.agentLevel == 0) {
                            temp.prizeInfo.depositStandard = numberWithCommas(temp.nextPrizeInfoLevelVo.depositStandard);
                            temp.prizeInfo.volumeStandard = numberWithCommas(temp.nextPrizeInfoLevelVo.volumeStandard);
                            //
                            temp.prizeInfo.gifts.giftName = numberWithCommas(temp.nextPrizeInfoLevelVo.gifts[0].giftName);
                            temp.prizeInfo.gifts.giftCode = temp.nextPrizeInfoLevelVo.gifts[0].giftCode;
                        } else {
                            temp.prizeInfo.depositStandard = numberWithCommas(temp.prizeInfoLevelVo.depositStandard);
                            temp.prizeInfo.volumeStandard = numberWithCommas(temp.prizeInfoLevelVo.volumeStandard);
                            //
                            temp.prizeInfo.gifts.giftName = numberWithCommas(temp.prizeInfoLevelVo.gifts[0].giftName);
                            temp.prizeInfo.gifts.giftCode = temp.prizeInfoLevelVo.gifts[0].giftCode;
                        }
                        if (temp.agentLevel > 1 && temp.agentGoldLevel > 1) {
                            temp.goldInfo.goldLot = numberWithCommas(temp.goldPrizeLevelVo.goldLot);
                            temp.goldInfo.goldPrize.giftName = numberWithCommas(temp.goldPrizeLevelVo.goldPrize[0].giftName);
                        } else {
                            temp.goldInfo.goldLot = numberWithCommas(temp.nextGoldPrizeLevelVo.goldLot);
                            temp.goldInfo.goldPrize.giftName = numberWithCommas(temp.nextGoldPrizeLevelVo.goldPrize[0].giftName);
                        }
                    }
                }

                if (this.eventStatus == 'status2' || this.eventStatus == 'status3' || this.eventStatus == 'status4' || this.eventStatus == 'status5') {

                    this.previousResultApiData = data.data[this.eventTypeList[0]][0];
                }

                this.resultApiData = data.data[this.latestEvent][0];

            }
            await this.levelPrizeList()

            this.searchLevel(this.levelPrizeApiData)
        },
        async timerInit() {
            const { data } = await activityTime();
            if (!data?.data) return;

            // Extract event and annual event types
            this.eventTypeList = Object.keys(data.data.events || {});
            this.annualEventTypeList = Object.keys(data.data.annuals || {}).sort();

            if (!this.eventTypeList.length || !this.annualEventTypeList.length) return;

            // Get latest and previous event names
            const latestEvent = this.eventTypeList[this.eventTypeList.length - 1];
            const previousEvent = this.eventTypeList[0];
            const latestAnnualEvent = this.annualEventTypeList[this.annualEventTypeList.length - 1];
            const previousAnnualEvent = this.annualEventTypeList[0];

            this.commonStore.setPreviousEventName(previousEvent);

            // Determine latest event status
            const latestEventData = data.data.events[latestEvent]?.[0];
            const previousEventData = data.data.events[previousEvent]?.[0];

            if (latestEventData && latestEventData.ongoingStatus != 'status1') {
                this.latestEvent = latestEvent;
                this.previousEventStatus = previousEventData?.ongoingStatus || null;

                this.dateToCount = latestEventData?.nextDate || null;
                this.eventStatus = latestEventData?.ongoingStatus || null;
            } else {
                this.latestEvent = previousEvent;

                this.dateToCount = previousEventData?.nextDate || null;
                this.eventStatus = previousEventData?.ongoingStatus || null;
            }

            // Determine latest annual event status
            const latestAnnualEventData = data.data.annuals[latestAnnualEvent]?.[0];
            const previousAnnualEventData = data.data.annuals[previousAnnualEvent]?.[0];


            if (latestAnnualEventData && latestAnnualEventData.ongoingStatus !== 'status1') {
                this.latestAnnualEvent = latestAnnualEvent;
                this.previousAnnualEventStatus = previousAnnualEventData?.annualOngoingStatus || null;

                this.annualDateToCount = latestAnnualEventData?.annualNextDate || null;
                this.annualEventStatus = latestAnnualEventData?.annualOngoingStatus || null;
            } else {
                this.latestAnnualEvent = previousAnnualEvent;
                // this.previousAnnualEventStatus = previousAnnualEventData?.annualOngoingStatus || null;
                this.annualDateToCount = previousAnnualEventData?.annualNextDate || null;
                this.annualEventStatus = previousAnnualEventData?.annualOngoingStatus || null;
            }




        },
        async getClaimedPrizeRecordList() {
            const response = await getClaimedPrizeRecord();
            const data: claimedPrizeRecord = response.data.data;

            const claimedData = Object.fromEntries(Object.entries(data).filter(([key, value]) =>
                value.giftType == 5));

            if (Object.keys(claimedData).length > 0) {
                this.isAnnualPrizeClaimed = claimedData[0]
            }


        },

        checkValidCountryCode(data: string) {
            const validCountry = ['CN', 'TW', 'TC']
            if (validCountry.includes(data.toUpperCase())) {
                return true;
            } else {
                return false;
            }
        },

        searchLevel(levels: LevelList[]) {
            // Determine the target level based on event status
            let targetLevel = this.resultApiData.agentLevel

            // Adjust target level if it's out of bounds
            if (targetLevel === 0) {
                targetLevel = 1;  // Ensure the minimum level is 1
            } else if (targetLevel === 10) {
                targetLevel = 9;  // Ensure the maximum level is 9
            }
            // targetLevel = 9
            // Find the index of the target level
            const levelIndex = levels.findIndex(level => level.level === targetLevel);

            if (levelIndex === -1) {
                // Level not found, exit function
                return null;
            }

            // Extract current, left, and right levels
            const currentLevel = levels[levelIndex];
            const leftLevel = levels[levelIndex - 1] || null;  // Use null if no left level exists
            const rightLevel = levels[levelIndex + 1] || null; // Use null if no right level exists

            // Clear the prizeList before pushing new data
            this.resultApiData.prizeList = [];

            // Create an array of non-null levels
            const levelsToPush = [currentLevel, leftLevel, rightLevel].filter(level => level);

            // Sort levels in ascending order by their `level` property
            levelsToPush.sort((a, b) => a.level - b.level);

            // Push sorted levels into the prizeList
            levelsToPush.forEach(level => {
                this.resultApiData.prizeList.push(level);
            });
        },

        async levelPrizeList() {
            const { data }: { data: LevelList } = await getAllLevel(this.commonStore.agentLocation);

            for (const index in data) {
                data[index].depositStandard = numberWithCommas(data[index].depositStandard);

                data[index].volumeStandard = numberWithCommas(data[index].volumeStandard);
                data[index].goldLot = numberWithCommas(data[index].goldLot);
                for (const key in data[index].gifts) {
                    data[index].gifts[key].giftName = numberWithCommas(data[index].gifts[key].giftName)
                }
                for (const key in data[index].goldPrize) {

                    data[index].goldPrize[key].giftName = numberWithCommas(data[index].goldPrize[key].giftName)
                }
            }

            this.levelPrizeApiData = data;

        },
        selectElement() {
            const elementId1 = 'agentResultTab'
            const elementId2 = 'tab_1'

            let element = document.getElementById(elementId1);
            if (!element) {
                element = document.getElementById(elementId2);
            }
            if (element) {
                // Do something with the element, like adding a class
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    },
    mounted() {
        this.tokenApi();
        this.timerInit();
    },
}
</script>
<style lang="scss" scoped>
$cdn: 'https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/ib_event/ib6/images/';

main {
    background: url($cdn + "bg@2x.png") no-repeat center top;
    max-width: 600px;
    margin: 0 auto;
    position: relative;

    .cover {
        position: absolute;
        height: 93px;
        max-width: 600px;
        width: 100%;
        background-image: linear-gradient(to bottom, #fff 50%, rgba(255, 255, 255, 0) 90%);
    }

    .double_arrow {
        position: relative;

        .scroll_wrapper {
            cursor: pointer;
            animation: MoveUpDown 1s linear infinite;
            left: 0;
            bottom: 0;
            display: inline-block;
            position: absolute;
            z-index: 1;
            top: -130px;
            left: 50%;
            transform: translate(-50%, -50%);

            .arrow1 {
                border: solid #d91d22;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 3px;
                position: absolute;
                top: 0;
                left: 0;


                &.down {
                    transform: rotate(45deg);
                    -webkit-transform: rotate(45deg);
                }
            }

            .arrow2 {
                border: solid #d91d22;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 3px;
                position: absolute;
                top: 7px;
                left: 0;

                &.down {
                    transform: rotate(45deg);
                    -webkit-transform: rotate(45deg);
                }
            }

            .arrow-spacer {
                display: block;
                height: 0px;
                /* Adjust to control the space between arrows */
            }

            @keyframes MoveUpDown {

                0%,
                100% {
                    transform: translateY(0);
                }

                50% {
                    transform: translateY(-5px);
                }
            }
        }
    }





    .marquee_wrapper {
        display: flex;
        justify-content: center;
        height: 80px;
        margin-top: -16px;
        margin-bottom: 24px;
        // position: absolute;
        // z-index: 1;
        // top: -80px;
        // left: 50%;
        // transform: translate(-50%, -50%);


        .marquee_content {
            display: flex;
            align-items: center;

            .title {
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: 1px;
                text-align: center;
                color: #000;
            }

            .content {
                margin: 0 0 0 24px;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: 1px;
                text-align: center;
                color: #979797;

                span {
                    font-size: 16px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    text-align: left;
                    color: #d91d22;
                }
            }
        }
    }



}

.child_bg {
    background: url($cdn + "child_bg.png") no-repeat center top;
    max-width: 600px;
    margin: 0 auto;
}
</style>
